import "./elements";
import "./logger";
import { flow } from "./flow";
import { loadDatalayer } from "./utils/loadDatalayer";

loadDatalayer();
flow();

if (import.meta.env.DEV) {
  (async () => {
    const { startAxe } = await import("./utils/axe");
    startAxe();
  })();
}
